import { useState } from 'react';
import SectionHeading from '@/components/feature/SectionHeading';
import { faqList } from '@/mocks/faq';

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(faqList[0].id);

  return (
    <section id="faq" className="w-full bg-background-50 px-4 md:px-8 py-14 md:py-20 scroll-mt-20">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
        <div className="lg:col-span-4">
          <SectionHeading
            eyebrow="常见问题"
            title="关于更新与浏览的常见问题"
            description="把浏览过程中最常被问到的几个问题集中在这里，点击标题即可展开查看说明。"
          />
        </div>

        <div className="lg:col-span-8">
          <div className="rounded-lg border border-background-200 overflow-hidden divide-y divide-background-200 bg-background-100">
            {faqList.map((item) => {
              const isOpen = item.id === openId;
              return (
                <div key={item.id}>
                  <h3>
                    <button
                      type="button"
                      onClick={() => setOpenId(isOpen ? null : item.id)}
                      aria-expanded={isOpen}
                      aria-controls={`${item.id}-panel`}
                      className="w-full flex items-center justify-between gap-4 p-4 md:p-5 text-left hover:bg-background-200/60 transition-colors cursor-pointer"
                    >
                      <span className="text-sm md:text-base font-bold text-foreground-950">{item.question}</span>
                      <span
                        className={`w-7 h-7 shrink-0 rounded-full flex items-center justify-center border transition-colors ${
                          isOpen
                            ? 'bg-primary-500 text-background-50 border-primary-500'
                            : 'border-background-300 text-foreground-700'
                        }`}
                      >
                        <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'} aria-hidden="true"></i>
                      </span>
                    </button>
                  </h3>
                  {isOpen ? (
                    <div id={`${item.id}-panel`} className="px-4 md:px-5 pb-4 md:pb-5 -mt-1">
                      <p className="text-xs md:text-sm leading-relaxed text-foreground-700">{item.answer}</p>
                    </div>
                  ) : null}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}